import PropTypes from "prop-types";
import React from "react";
import { Box, Link, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useFormikContext } from "formik";
import HTMLEditor from "../../HtmlEditor/HtmlEditor";
import TextFieldUploadButton from "../../Buttons/TextFieldUploadButton";
import { repositoryFileMimeTypes } from "../../../constants";
import Tags from "../../Tags/Tags";

const AttachmentFields = ({ files, onAddFile, onRemoveFile, disabled }) => {
  const { t } = useTranslation();
  const tags = files
    ? files.map(file => (
        <Link href={file.url} noWrap download={file.name}>
          {file.name}
        </Link>
      ))
    : [];
  return (
    <React.Fragment>
      <Typography variant="h6" sx={{ mt: 2, mb: 1.5 }}>
        {t("editHomework.addAttachmentsLabel")}
      </Typography>
      {files.length > 0 && (
        <Box mt={1} mb={1.5}>
          <Tags
            tags={tags}
            onDelete={(tag, index) => onRemoveFile(index, files[index])}
            disabled={disabled}
            enableAutocomplete={false}
          />
        </Box>
      )}
      <Box mt={1}>
        <TextFieldUploadButton
          disableUnderline={false}
          onFileUpload={onAddFile}
          helperText={t("courseBuilder.uploadFileHelperText")}
          acceptType={repositoryFileMimeTypes.join()}
          disabled={disabled}
          multiple
        />
      </Box>
    </React.Fragment>
  );
};

const EditHomeworkInstructions = ({
  disabled,
  instructionsAttachments,
  onRemoveAttachment,
  onAddAttachment
}) => {
  const { t } = useTranslation();
  const {
    values,
    setFieldValue,
    setFieldTouched,
    errors,
    touched
  } = useFormikContext();

  const handleNumCharactersChange = numCharacters => {
    setFieldValue("instructionsTextOnlyLength", numCharacters);
  };

  return (
    <Box display="flex" flexDirection="column" height="100%">
      <Typography variant="h6" sx={{ mt: 0.75, mb: 2.5 }}>
        {t("editHomework.addInstructionsLabel")}
      </Typography>
      <HTMLEditor
        disabled={disabled}
        height={260}
        disableResize
        disableUnderline
        disableMargin
        onChange={value => {
          setFieldTouched("instructions");
          setFieldValue("instructions", value, false);
        }}
        value={values.instructions}
        onFileAdd={(fileObj, tempLink, type) =>
          setFieldValue("instructionsFileList", [
            ...values.instructionsFileList,
            { fileObj, tempLink, type }
          ])
        }
        errorMessage={touched.instructions && errors.instructions}
        menubar={false}
        toolbar="link image media code | styleselect bold italic underline | outdent indent bullist | fontselect fontsizeselect forecolor"
        onNumCharactersChange={handleNumCharactersChange}
        characterLimit={800}
      />
      <AttachmentFields
        files={instructionsAttachments}
        onRemoveFile={onRemoveAttachment}
        onAddFile={onAddAttachment}
        disabled={disabled}
      />
    </Box>
  );
};

EditHomeworkInstructions.propTypes = {
  disabled: PropTypes.bool
};

export default EditHomeworkInstructions;
